import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="10 February 2026">
      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-2">1. Acceptance of Terms</h2>
      <p>
        By accessing or using <strong>Anubandh AI</strong> (the &quot;Platform&quot;, &quot;we&quot;, &quot;us&quot;), operated
        by <strong>Anubandh.ai</strong> (a proprietorship registered in Greater Noida, India), you agree to be legally
        bound by these Terms &amp; Conditions along with our Privacy Policy and Refund Policy. If
        you do not agree, please do not use the Platform.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">2. Eligibility</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>You must be at least 18 years of age (21+ for males, per Indian marriage laws).</li>
        <li>You must be legally competent to enter into a binding contract under Indian law.</li>
        <li>You must not be currently married. Providing false marital status is grounds for immediate termination.</li>
        <li>NRI / OCI users must comply with the applicable laws of their country of residence.</li>
      </ul>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">3. Nature of the Service</h2>
      <p>
        Anubandh AI is a <strong>Marriage Intelligence Platform</strong>. We offer AI-assisted
        compatibility assessment, personality insights, Vedic Kundali fusion, and curated
        recommendations. <strong>We are not a matrimonial agency, marriage bureau, or dating
        service.</strong> We do not guarantee marriage, engagement, or any relationship outcome.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">4. Account Registration</h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>You must provide accurate, current, and complete information.</li>
        <li>KYC verification (ID + selfie) is required to unlock matches and full reports.</li>
        <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        <li>One person = one account. Multiple accounts by the same individual are prohibited.</li>
      </ul>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">5. Subscription Tiers &amp; Payments</h2>
      <p>
        Anubandh AI offers three tiers: <strong>Discovery (Free)</strong>, <strong>Clarity (₹1,999/month)</strong>,
        and <strong>Journey (₹4,999/month)</strong>. All prices are inclusive of applicable Indian GST.
        Payments are processed securely via Razorpay. Subscriptions auto-renew unless cancelled at
        least 24 hours before the next billing cycle.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">6. User Conduct</h2>
      <p>You agree <strong>NOT</strong> to:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Impersonate another person or misrepresent your identity, age, or marital status.</li>
        <li>Post obscene, abusive, defamatory, or unlawful content.</li>
        <li>Solicit money, gifts, or personal financial information from other users.</li>
        <li>Use the Platform for any commercial purpose, dating, or hookup activity.</li>
        <li>Attempt to reverse-engineer, scrape, or automate access to the Platform.</li>
        <li>Share other users&apos; profile data outside your permissioned family circle.</li>
      </ul>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">7. Intellectual Property</h2>
      <p>
        All Platform content — including the Marriage Intelligence Report format, assessment
        questionnaire, Kundali fusion algorithm, brand assets, and code — is the exclusive property
        of Anubandh AI. Users retain rights to their submitted profile content but grant us a
        limited license to display it to matched users within the Platform.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">8. AI &amp; Astrological Content Disclaimer</h2>
      <p>
        Compatibility scores, AI recommendations, and Vedic Kundali (Ashtakoot Guna Milan) outputs
        are provided <strong>for informational and reflective purposes only</strong>. They are not
        a substitute for professional counsel — legal, medical, financial, or spiritual. Marriage
        is a significant life decision; please supplement our insights with personal judgment,
        family conversation, and qualified guidance.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">9. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Anubandh AI shall not be liable for any indirect,
        incidental, consequential, or punitive damages, including but not limited to: emotional
        distress, relationship outcomes, financial loss from user-to-user disputes, or loss of
        data. Our total aggregate liability shall not exceed the fees paid by you in the preceding
        6 months.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">10. Termination</h2>
      <p>
        We may suspend or terminate accounts that violate these Terms, without refund. You may
        delete your account at any time from your Profile page. Upon deletion, your data is purged
        within 30 days except where retention is legally required (e.g., financial records under
        the Income Tax Act).
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">11. Governing Law &amp; Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. All disputes shall be subject to the
        exclusive jurisdiction of the <strong>District Court of Greater Noida, Uttar Pradesh</strong>.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">12. Amendments</h2>
      <p>
        We may revise these Terms from time to time. Material changes will be notified via email
        and in-app notification. Continued use of the Platform after changes constitutes acceptance.
      </p>

      <h2 className="font-serif-display text-2xl text-[#1E1B4B] mt-8">13. Grievance Officer</h2>
      <p>
        Per Rule 3(2) of the IT (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021:
      </p>
      <ul className="list-none pl-0 space-y-1">
        <li><strong>Name:</strong> K. Singh</li>
        <li><strong>Designation:</strong> Founder &amp; Grievance Officer</li>
        <li><strong>Email:</strong> <a className="text-amber-700 underline" href="mailto:grievance@anubandh.ai">grievance@anubandh.ai</a></li>
        <li><strong>Response Time:</strong> Acknowledgement within 24 hours; resolution within 15 days.</li>
      </ul>

      <div className="mt-10 pt-6 border-t border-stone-200 text-xs text-stone-500">
        By using Anubandh AI, you acknowledge that you have read, understood, and agreed to these
        Terms &amp; Conditions.
      </div>
    </LegalLayout>
  );
}
